import {
  EDITOR_LOAD_DEFAULT_PAGE_BEGIN,
  EDITOR_LOAD_DEFAULT_PAGE_SUCCESS,
  EDITOR_LOAD_DEFAULT_PAGE_FAILURE,
  EDITOR_LOAD_DEFAULT_PAGE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadDefaultPage(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EDITOR_LOAD_DEFAULT_PAGE_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/pages/${projectId}/default-page`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EDITOR_LOAD_DEFAULT_PAGE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },

        (err) => {
          dispatch({
            type: EDITOR_LOAD_DEFAULT_PAGE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadDefaultPageError() {
  return {
    type: EDITOR_LOAD_DEFAULT_PAGE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_LOAD_DEFAULT_PAGE_BEGIN:
      return {
        ...state,
        loadDefaultPagePending: true,
        loadDefaultPageError: null,
      };

    case EDITOR_LOAD_DEFAULT_PAGE_SUCCESS:
      return {
        ...state,
        loadDefaultPagePending: false,
        loadDefaultPageError: null,
        defaultPage: action.data,
      };

    case EDITOR_LOAD_DEFAULT_PAGE_FAILURE:
      return {
        ...state,
        loadDefaultPagePending: false,
        loadDefaultPageError: action.data.error,
      };

    case EDITOR_LOAD_DEFAULT_PAGE_DISMISS_ERROR:
      return {
        ...state,
        loadDefaultPageError: null,
      };

    default:
      return state;
  }
}
